<template>
    <div class="bg-background-light border-b-[1px] border-bw-grey">
        <div class="pt-12 pb-28 flex flex-col align-center">
            <div class="container flex flex-col justify-center text-center py-12">
                <h1 class="responsive-title-2 font-bold mb-4">{{ t('terms.title') }}</h1>
                <h2 class="responsive-body-medium">{{ t('terms.subtitle') }}</h2>
            </div>
            <div class="container w-100 space-y-1">
                <div v-for="(item, index) in terms" :key="index" class="faq-item faq-question">
                    <div class="flex flex-col container justify-between">
                        <button @click="toggle(index)" class="flex justify-between align-center">
                            <div class="title-faq text-left responsive-title-5">{{ t(`terms.sections.${item.key}.title`) }}</div>
                            <span :class="{ 'chevron': true, 'open': item.open }">
                                <img src="@/assets/icons/svg/chevron.svg" alt="Chevron" />
                            </span>
                        </button>
                        <div v-if="item.open" class="faq-answer">
                            <div v-html="t(`terms.sections.${item.key}.content`)"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// import { ref } from 'vue';
import { ref } from 'vue';

import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const terms = ref([
    { key: 'service', open: false },
    { key: 'prices', open: false },
    { key: 'privacy', open: false },
    { key: 'payment', open: false },
    { key: 'cancellation', open: false },
    { key: 'correspondence', open: false },
    { key: 'reviews', open: false },
    { key: 'disclaimer', open: false },
    { key: 'intellectualProperty', open: false },
    { key: 'miscellaneous', open: false },
]);

const toggle = (index) => {
    terms.value[index].open = !terms.value[index].open;
};

</script>

<style scoped>
.faq-question {
    width: 100%;
    cursor: pointer;
    padding: 10px 0;
    border-bottom: 1px solid #eaeaea;
}

.faq-answer {
    padding: 10px 0;
    border-bottom: 1px solid #eaeaea;
    font-size: 16px;
    color: #8C8B94;
}

.chevron {
    transition: transform 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 1px solid #8C8B94;
    transform: rotate(-90deg);
}

.chevron.open {
    transform: rotate(90deg);
}

.title-faq {
    width: 80% !important;
}
</style>
